const OpenGameReducers = (state = false, action) => {
  switch (action.type) {
    case "openGame":
      return (state = true);
    case "closeGame":
      return (state = false);
    default:
      return state;
  }
};
export default OpenGameReducers;
